import React, { Component } from 'react'
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import request from "../../../lib/requester";

class SetupPackage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      Package_Name: '',
      Package_Alias: '',
      Package_Rate: null,
      Package_Program_Type: '',
      Package_Start_Date: '',
      Package_End_Date: '',
      Package_Is_Active: '',
      Package_ID: '',
      lovProgram: [],
      is_update: false,
      success: '',
      error: [],
      User: JSON.parse(window.localStorage.getItem('is_user'))
    }
  }

  componentDidMount = () => {
    this.getDataProgramType()
    let qs = this.props.location.search.replace("?", "")
    let id = ""
    if (qs.length > 0) {
      let qss = qs.split("=")
      id = qss[1]
    }
    if (parseInt(id) > 0) {
      this.getDetailPackage(id)
    }
  }

  getDetailPackage = (id) => {
    let url = '/api/traces_chd/v1/package/detail?id=' + id

    this.setState({ loading: true })
    request.getCHD(url, {
      success: function(response) {
        let { data } = response.data
        this.setState({ 
          loading: false,
          Package_ID: id,
          Package_Name: data.package_name,
          Package_Alias: data.package_alias,
          Package_Rate: data.package_rate,
          Package_Start_Date: data.start_date ? new Date(data.start_date) : '',
          Package_End_Date: data.end_date ? new Date(data.end_date) : '',
          Package_Is_Active: data.is_active,
          Package_Program_Type: data.program_type_id,
          is_update: true
        })
      }.bind(this),
      error: function(e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}><i class="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  getDataProgramType = () => {
    let url = '/api/traces_chd/v1/program/data-program'
    request.getCHD(url, {
      success: function (response) {
        let { ProgramType } = response.data.data
        this.setState({
          lovProgram: ProgramType
        })
      }.bind(this),
      error: function (e) {
        console.log(e.message)
      }
    })
  }

  handleStartDate = (date) => {
    this.setState({ Package_Start_Date: date })
  }

  handleEndDate = (date) => {
    this.setState({ Package_End_Date: date })
  }

  renderLovProgram = () => {
    return (
      <select className="form-control" disabled={this.state.is_update} value={this.state.Package_Program_Type} name="Package_Program_Type" onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select Program -</option>
        {
          this.state.lovProgram.map((item, index) => (
            <option key={index} value={item.prog_type_id}>{item.program_name}</option>
          ))
        }
      </select>
    )
  }

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    this.setState({ [name]: value });
  };

  handleSubmit = () => {
    let url = this.state.is_update ? '/api/traces_chd/v1/package/update' : '/api/traces_chd/v1/package/create'
    let param = {
      package_name: this.state.Package_Name,
      program_type_id: this.state.Package_Program_Type,
      package_alias: this.state.Package_Alias,
      package_rate: this.state.Package_Rate,
      start_date: this.state.Package_Start_Date,
      end_date: this.state.Package_End_Date,
      is_active: this.state.Package_Is_Active,
      id: this.state.is_update ? this.state.Package_ID : ''
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function(response) {
        let { message } = response.data
        window.scrollTo(0,0)
        this.setState({ loading: false, success: message })

        let app = this
        window.setTimeout(() => {
          app.props.history.push('/admin/setup/package/list')
        }, 2000)
      }.bind(this),
      error: function(e) {
        let { message } = e.response.data
        this.setState({ loading: false, error: [message || 'Failed to submit'] })
      }.bind(this)
    })
  }
  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-header">Form Package</div>
                  <div className="card-body">
                    {this.showNotification()}
                    <form className="">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Package Name</label>
                            <input type="text" disabled={this.state.is_update} className="form-control" autoComplete="off" name="Package_Name" onChange={this.handleChangeInput.bind(this)} value={this.state.Package_Name} />
                          </div>
                          <div className="form-group">
                            <label>Program Type</label>
                            {this.renderLovProgram()}
                          </div>
                          <div className="form-group row">
                            <label className="col-md-2 mt-1">Start Date</label>
                            <div className="col-md-4">
                              <DatePicker
                                selected={this.state.Package_Start_Date}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleStartDate}
                              />
                            </div>
                            <label className="col-md-2 mt-1">End Date</label>
                            <div className="col-md-4">
                              <DatePicker
                                selected={this.state.Package_End_Date}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleEndDate}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label>Is Active</label>
                            <div class="ml-2 custom-control custom-radio">
                              <input type="radio" id="customRadio1" checked={this.state.Package_Is_Active === 'Y' ? true : false} name="Package_Is_Active" className="custom-control-input" value="Y" onClick={this.handleChangeInput.bind(this)} />
                              <label class="custom-control-label" for="customRadio1">Yes</label>
                            </div>
                            <div class="ml-2 custom-control custom-radio">
                              <input type="radio" id="customRadio2" checked={this.state.Package_Is_Active === 'N' ? true : false} name="Package_Is_Active" className="custom-control-input" value="N" onClick={this.handleChangeInput.bind(this)} />
                              <label class="custom-control-label" for="customRadio2">No</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Package Alias</label>
                            <input type="text" disabled={this.state.is_update} className="form-control" autoComplete="off" name="Package_Alias" onChange={this.handleChangeInput.bind(this)} value={this.state.Package_Alias} />
                          </div>
                          <div className="form-group">
                            <label>Package Rate</label>
                            <input type="text" disabled={this.state.is_update} className="form-control" autoComplete="off" name="Package_Rate" onChange={this.handleChangeInput.bind(this)} value={this.state.Package_Rate} />
                          </div>
                        </div>
                      </div>
                        <div className="row">
                          <div className="col-md-3">
                            <button type="button" className="btn btn-primary btn-block" onClick={this.handleSubmit.bind(this)}><i className="fa fa-save" /> Save</button>
                          </div>
                          <div className="col-md-3">
                            <button type="button" className="btn btn-warning btn-block" onClick={() => { this.props.history.push('/admin/setup/package/list')}}><i className="fa fa-arrow-left" /> Back</button>
                          </div>
                        </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default SetupPackage